<ion-backdrop *ngIf="showMoreOptions"></ion-backdrop>
<div [@slideMoreOptions]="showMoreOptions" [hidden]="!showMoreOptions" class="more-options">
  <ion-tab-button *ngFor="let option of moreOptions" [class]="option.styles" (click)="option?.handler()">
    <p class="mapfre-fs-s mapfre-fw-500">{{ option.text | translate }}</p>
    <img [src]="option.icon" width="32px" height="32px" [alt]="option.id"/>
  </ion-tab-button>
</div>

<div class="home-tabs">
  <ion-tab-bar slot="bottom">
    <ion-tab-button class="mapfre-mr-m" (click)="onOpenAllProducts()">
      <img
        src="assets/images/menu/products.svg"
        width="24px"
        height="24px"
        alt="products"
        class="mapfre-mb-xs"
      />
      <ion-label class="home-tabs--title mapfre-fw-500">{{ 'CLIENT_AREA.HOME.MY_PRODUCTS' | translate }}</ion-label>
    </ion-tab-button>

    <ion-tab-button class="mapfre-ml-m" (click)="onOpenTeCuidamos()">
      <img
        src="assets/images/menu/te-cuidamos.svg"
        width="24px"
        height="24px"
        alt="te-cuidamos"
        class="mapfre-mb-xs"
      />
      <ion-label class="home-tabs--title mapfre-fw-500">{{ 'CLIENT_AREA.CA_MENU.TE_CUIDAMOS' | translate }}</ion-label>
    </ion-tab-button>
  </ion-tab-bar>

  <ion-fab vertical="bottom" horizontal="center">
    <ion-fab-button (click)="onToggle()" class="more-options-button">
      <ion-icon
        color="white"
        [name]="showMoreOptions ? 'close-outline' : 'add'"
        class="more-options-button--icon"
      ></ion-icon>
    </ion-fab-button>
  </ion-fab>
</div>
